import React from 'react';
import { Image as GlobalImage, ImageProps } from 'components/Image';

export const Image: React.FC<ImageProps> = GlobalImage;
